module.exports = __webpack_public_path__ + "img/logo-al-dalal.78211bf8.png";